export default {"src":"/_next/static/media/close.6764eda4.svg","height":492,"width":492};